import React, {useState, useEffect} from 'react'

import "styles/components/popup.sass"
import "pages/Styles/UIKit.sass"

import Popup from "../../../components/Popup";
import notifyUser, {notifyAboutError} from "../../../methods/notifyUser";
import {httpClient} from "../../../funcs";
import {connect} from "react-redux";
import {useRoute} from "react-router5";
import {HelpView} from "../../Common/HelpView";
import ApiKeyField from "../../../components/ApiKeyField";
import { AdditionalServiceType } from "../../../util/AdditionalServiceType";

type Props = {
    close: Function,
    amoConfig: any,
    $store: any,
    $commitToStore: Function,
}

let AmoCRMIntegrationPopup: any = function AmoCRMIntegrationPopup(props: Props) {
    const $router = useRoute()
    const [configurationTariffs, setConfigurationTariffs] = useState<any[]>([])

    useEffect(() => {
        loadConfigurationTariffs()
    }, [])

    async function loadConfigurationTariffs() {
        try {
            const {data: tariffs} = await httpClient.get("/configuration-tariffs");
            setConfigurationTariffs(tariffs)
        } catch(error) {
            notifyAboutError(props, error)
        }
    }

    function getConfigurationPrice(type: string): number {
        const tariff = configurationTariffs.find(t => t.type === type)
        return tariff ? tariff.price / 100 : 1500
    }

    function goToTariffsWithAmoConfiguration() {
        props.close()
        localStorage.setItem('tariffs_active_tab', JSON.stringify('Тарифы'))
        $router.router.navigate(
            'packages-v2',
            {
                add_to_cart: AdditionalServiceType.AMO_CONFIGURATION,
            },
            { reload: false }
        )
    }

    function onCopy() {
        notifyUser(props, "Строка скопирована. Теперь вставьте ее в настройках виджета в amoCRM");
    }

    function apiKey() {
        return `${props.$store.userSession.realty_api_key}`
    }

    return <Popup
        maxWidth="650px"
        onClose={() => {
            props.close()
        }}
    >
        <div>
            <HelpView
                title={"Интеграция с amoCRM"}
                subtitle={"Интеграция добавляет виджет ОкиДоки в карточку сделки в amoCRM.\n" +
                    "Создавать договоры можно прямо из карточки сделки, при этом, есть возможность указать необходимый шаблон и карточку подписанта!\n" +
                    "Все изменения статусов договора будут добавлены как комментарии в карточку сделки. \n" +
                    "\n" +
                    "Подробнее о том, как работает интеграция и как ее настроить, смотрите в нашем видео"}
                videoId={"96dX3tVahPw"}
                rutubeVideoId={"79eb7276204fe0a26b87375318133ee6"}
            />
            <hr className="newHR"/>
            <div className="Body_15" style={{textAlign: "left"}}>
                Чтобы настроить интеграцию с amoCRM - скопируйте ключ и вставьте его в настройках виджета и следуйте дальнейшим инструкциям
            </div>
            <div>
                <ApiKeyField
                    title="Ключ API"
                    value={apiKey()}
                    onCopy={onCopy}
                />

                <hr className="newHR"/>
                <div className="commonLabel" style={{marginTop: "20px"}}>
                    Нужна помощь с настройкой?
                </div>
                <div className="commonSubtitle" style={{marginTop: "10px"}}>
                    Наши специалисты помогут настроить интеграцию с amoCRM. Услуга будет добавлена в корзину на странице тарифов. Мы:
                    <ul style={{marginTop: "10px"}}>
                        <li>Настроим виджет в вашей amoCRM</li>
                        <li>Поможем настроить шаблоны договоров</li>
                        <li>Проведем тестовое создание договора</li>
                        <li>Обучим ваших сотрудников работе с интеграцией</li>
                    </ul>
                </div>
                <button
                    className="new withTitle _wa"
                    style={{marginTop: "15px"}}
                    onClick={goToTariffsWithAmoConfiguration}
                >
                    <div className="buttonsContainer">
                        <span>Перейти к оплате (от {getConfigurationPrice('amo_configuration')} ₽)</span>
                    </div>
                </button>

                <hr className="newHR"/>
                <button
                    className="new withTitle _wa"
                    style={{marginTop: "15px"}}
                    onClick={() => {
                        props.close()
                    }}
                >
                    <div className="buttonsContainer">
                        <span>Закрыть</span>
                    </div>
                </button>
            </div>
        </div>
    </Popup>
}

AmoCRMIntegrationPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(AmoCRMIntegrationPopup)

export default AmoCRMIntegrationPopup
